import { h, Fragment } from 'preact'
import { Button } from './Button.jsx'
import { Heart } from './Icon.jsx'
import { naturalLanguageJoin } from './../utility/naturalLanguageJoin'

import { SavedJobsButton } from './SavedJobsButton.jsx'
import { useLocalStorage } from './../hooks/useLocalStorage'
import { filter } from './../utility/object'


export function JobListing({job, ...props }) {

	const { 
		job_featured, 
		url, 
		job_title, 
		location = [], 
		job_site_categories = [], 
		timeago 
	} = job

	const job_image = job.job_image || '/wp-content/themes/direct-line/assets/img/dlg-logo.svg'

	const [jobs, setSaved] = useLocalStorage('savedJobs', {})
	const saved = jobs[job.id] || false

	const save = () => {
		const record = {
			id : job.id,
			title : job.job_title,
			subtitle : job.location.map(job => job.location_city).join(', '),
			href : job.url
		}
		setSaved({...jobs, [job.id] : record })
	}

	const unsave = () => {
		setSaved({ ...jobs, [job.id] : undefined })
	}
	
	return <div class="job-listing">
	    <div class="flex">
	        <div class="job-listing__details first-last">
	        	{job_featured && <small>Featured<br/></small>}
	            <h4 class="job-listing__title strong">
	                <a href={url}>{job_title}</a>
	            </h4>

	            {(job_site_categories || []).map(cat => {
	            	return <span class="job-listing__tag">{cat}</span>
	            })}

	            {location.length > 0 && <>
	            	<div className="job-listing__locations margin-top-1">
		            	<small>{naturalLanguageJoin(
		            		location.map(loc => loc.location_city).filter(Boolean)
		            	)}</small>
	            	</div>
	            </>}
	            
	        </div>
	        {/* TODO: job image */}
	        {job_image && <div class="job-listing__rightcol">
	            <a href={url} class="job-listing__thumb relative">
	                <img 
	                	class="object-fit--contain" 
	                	src={job_image}
	                	alt="Direct Line Group" 
	                />
	            </a>
	        </div>}
	    </div>
	    <div class="job-listing__meta grid flex-align-center flex-space-between margin-top-1">
	        <small>{timeago}</small>
	        
	        <SavedJobsButton 
	        	saved={saved} 
	        	save={save} 
	        	unsave={unsave}
	        	variant="ghost small" 
	        	iconRight={Heart}
	        />
	    </div>
	</div>
}